module.exports = require("underscore");


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 37
// module chunks = 0